import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { borrowerAPI } from '../../services/api';
import { toast } from 'sonner';

const BorrowerDeals = () => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDeals();
  }, []);

  const fetchDeals = async () => {
    try {
      const response = await borrowerAPI.getDeals();
      setDeals(response.data);
    } catch (error) {
      toast.error('Failed to load deals');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="My Deals">
      <div className="space-y-6">
        {loading ? (
          <p>Loading...</p>
        ) : deals.length === 0 ? (
          <Card>
            <CardContent className="py-8 text-center">
              <p className="text-slate-500">No deals found</p>
            </CardContent>
          </Card>
        ) : (
          deals.map((deal) => (
            <Link key={deal.id} to={`/borrower/deals/${deal.id}`}>
              <Card className="hover:shadow-md transition">
                <CardHeader>
                  <CardTitle>{deal.deal_nickname}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p>Status: {deal.status}</p>
                  <p>Location: {deal.property_city}, {deal.property_state}</p>
                </CardContent>
              </Card>
            </Link>
          ))
        )}
      </div>
    </Layout>
  );
};

export default BorrowerDeals;